import { render, staticRenderFns } from "./ReleasesArtistsEditPanelDialog.vue?vue&type=template&id=69b5526c"
import script from "./ReleasesArtistsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./ReleasesArtistsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports